<template>
	<ButtonGroup>
		<NavButton v-if="show('submit')" :invert="invert" to="Submit"
			><span class="label"
				><Icon name="submit" /><span>{{ getLabel('submit') }}</span></span
			></NavButton
		>
		<SpinnerButton
			v-if="show('vote')"
			:class="btnClasses"
			:loading="loadingSession"
			@click.native="startSession"
			><span class="label"
				><Icon name="vote" /><span>{{ getLabel('vote') }}</span></span
			></SpinnerButton
		>
		<NavButton v-if="show('leaderboard')" :invert="invert" to="Leaderboard"
			><span class="label"
				><Icon name="leaderboard" /><span>{{
					getLabel('leaderboard')
				}}</span></span
			></NavButton
		>
		<NavButton v-if="show('gallery')" :invert="invert" to="Gallery"
			><span class="label"
				><Icon name="gallery" /><span>{{ getLabel('gallery') }}</span></span
			></NavButton
		>
	</ButtonGroup>
</template>

<script>
import ButtonGroup from '@/components/main/ButtonGroup'
import NavButton from '@/components/main/NavButton'
import SpinnerButton from '@/components/main/SpinnerButton'
import Icon from '@/components/main/Icon'
import campaign from '@/mixins/campaign'
import session from '@/mixins/session'

const BUTTONS = ['submit', 'vote', 'leaderboard', 'gallery']
const LABELS = {
	submit: 'Submit your entry',
	vote: 'Vote for your faves',
	leaderboard: 'Check leaderboard',
	gallery: 'View gallery'
}

const resolveButtonStateToggle = (campaign, btn) => {
	switch (btn) {
		case 'submit':
			return !!campaign.allowSubmissions
		case 'vote':
			return !!campaign.allowVoting
		case 'leaderboard':
			return !!campaign.showLeaderboard
		case 'gallery':
			return !!campaign.showGallery
		default:
			return false
	}
}

export default {
	name: 'StateButtons',
	props: {
		invert: {
			type: Boolean,
			default: false
		},
		exclude: {
			type: Array,
			validator: v => v.every(btn => BUTTONS.includes(btn)),
			default: () => []
		},
		labels: {
			type: Object,
			validator: v =>
				Object.entries(v).every(([btn, label]) => {
					return BUTTONS.includes(btn) && typeof label === 'string'
				}),
			default: () => ({})
		}
	},
	computed: {
		btnClasses() {
			return this.invert ? 'button invert' : 'button'
		}
	},
	methods: {
		show(btn) {
			return (
				!this.exclude.includes(btn) &&
				resolveButtonStateToggle(this.campaign, btn)
			)
		},
		getLabel(btn) {
			return this.labels[btn] || LABELS[btn]
		}
	},
	mixins: [campaign, session],
	components: {
		ButtonGroup,
		NavButton,
		SpinnerButton,
		Icon
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';
.button {
	&:not(.invert) {
		@include button($blue-48, $white, $blue-48, $blue-98);
	}
	&.invert {
		@include button;
	}
}

.label {
	display: flex;
	align-items: center;
	height: 100%;

	svg {
		@include square(2rem);
	}

	> :not(:last-child) {
		margin-right: 0.5rem;
	}
}
</style>
